import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const Explosive = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2074_7795)">
      <path d="M4 28H28V4L25 18L18 8L22 20L4 12L20 25L4 28Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_2074_7795">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'Explosive'
);
